import { useState } from "react";
import type { FormEvent } from "react";
import { navLinks } from "@/mocks/archiveEntries";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    setMenuOpen(false);
    document.getElementById("archive")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="sticky top-0 z-50">
      {/* 运营壳状态条 */}
      <div className="hidden md:block bg-foreground-950 text-background-100">
        <div className="mx-auto flex w-full max-w-[1240px] items-center justify-between px-4 md:px-6 py-2 text-[12px] tracking-wide">
          <div className="flex items-center gap-2">
            <span className="relative flex h-2 w-2 items-center justify-center">
              <span className="absolute inline-flex h-2 w-2 animate-ping rounded-full bg-accent-500/70" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
            </span>
            <span>留档档案库 · 全域完整备份运行中</span>
          </div>
          <div className="flex items-center gap-4 text-background-200">
            <span className="hidden lg:inline">最近更新 2026-09-12</span>
            <span className="hidden lg:inline text-foreground-700">|</span>
            <span>完整性校验 · 通过</span>
            <span className="text-foreground-700">|</span>
            <span className="text-accent-300">批次编号可用</span>
          </div>
        </div>
      </div>

      {/* 主导航 */}
      <nav className="border-b border-background-200 bg-background-50/90 backdrop-blur-md">
        <div className="mx-auto flex w-full max-w-[1240px] items-center justify-between gap-6 px-4 md:px-6 h-[72px]">
          <a href="#top" className="flex items-center gap-3 shrink-0">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50 text-xl">
              <i className="ri-archive-drawer-line" />
            </span>
            <span className="leading-tight">
              <span className="block font-heading text-lg font-bold tracking-wide text-foreground-950">
                黑料看料
              </span>
              <span className="block text-[11px] tracking-[0.28em] text-foreground-500">
                存档 · 留档
              </span>
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-7">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <form
              onSubmit={handleSearch}
              className="hidden xl:flex items-center gap-2 rounded-full border border-background-300 bg-background-100 pl-4 pr-1 py-1"
            >
              <i className="ri-search-line text-base text-foreground-500" />
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="批次号 / 关键词"
                className="w-40 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
              />
              <button
                type="submit"
                className="rounded-full bg-secondary-500 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-secondary-600 whitespace-nowrap"
              >
                检索
              </button>
            </form>

            <a
              href="#archive"
              className="hidden sm:inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              进入存档库
              <i className="ri-arrow-right-line" />
            </a>

            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label="展开菜单"
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-xl text-foreground-800 lg:hidden cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="rounded-md px-3 py-3 text-sm text-foreground-800 transition-colors hover:bg-background-100"
                >
                  {link.label}
                </a>
              ))}
            </div>
            <a
              href="#archive"
              onClick={() => setMenuOpen(false)}
              className="mt-3 flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50"
            >
              进入存档库
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Navbar;